import { useFiltersV2Actions, useFiltersV2Select } from "PFApp/components/filters_v2";
import Toggle from "PFComponents/toggle/toggle";
import { useTranslation } from "react-i18next";

import css from "./filters_v2_auto_refresh_toggle.module.scss";

export const FiltersV2AutoRefreshToggle = () => {
  const { t } = useTranslation("filters", { keyPrefix: "panel" });

  const { isAutoRefreshOn } = useFiltersV2Select("isAutoRefreshOn");
  const { toggleAutoRefresh } = useFiltersV2Actions();

  return (
    <Toggle
      inline
      className={css.autoRefreshToggle}
      label={t("autoRefresh")}
      checked={isAutoRefreshOn}
      onChange={toggleAutoRefresh}
      reversed
      compact
    />
  );
};
